export const NLP_EVENTS = {
  NLP_PAGELOAD: 'native_landing_page_loads',
  BANNER_CLICKED: 'banner_clicked',
};
